import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { changeAuth } from "../actions/loginAction";
import host from "../host";
import { useDispatch } from "react-redux";
import MessageSnackbar from "../_layout/elements/snackbar";

export default function DeleteFile(props) {
  //delete brain functionality starts

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const [loading, setLoading] = useState(false);

  const handleDeleteFile = (knowledge_id) => {
    setLoading(true);
    fetch(host.chaturl + `/knowledge/${knowledge_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          setLoading(false);
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setLoading(false);
          props.setSeverity("error");
          props.setMessage("Something went wrong");
          props.setSnackbar(true);
        }
      })
      .then((data) => {
        if (data.success) {
          props.getBrains();
          props.handleClosedelete();
          setLoading(false);
          props.setSeverity("success");
          props.setMessage("File Deleted Successfully.");
          props.setSnackbar(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error uploading file:", error);
      });
  };

  //delete brain functionality ends

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <Modal open={props.opendelete} onClose={props.handleClosedelete} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w35 ">
          <Link className="close" onClick={props.handleClosedelete}>
            X
          </Link>
          <div className="modal-body">
          <div className="popup_scroller">
            <div className="model-content text-center">
              <h3>Are you sure you want to delete?</h3>
            </div>
            <div className="modal-btn">
              <button
                className="btn btn-success btn-block  "
                onClick={() => {
                  handleDeleteFile(props?.brain?.id);
                }}
                disabled={loading}
              >
                {loading?"Deleting...":"Delete forever"}
              </button>
              <button className="btn btn-danger btn-block  " onClick={props.handleClosedelete} disabled={loading}>
                Cancel
              </button>
            </div>
          </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
